{
	"ReportPortalInfo_UpgradeTo_Enterprise": "Upgrade to Enterprise to access this feature",
	"ReportPortalInfo_UpgradeTo_Enterprise_MST": "Upgrade to CXA Advanced (Historic) to access this feature",
	"ReportPortalInfo_UpgradeTo_Call Centre Supervisor": "Upgrade to Call Centre Supervisor to access this feature",
	"ReportPortalInfo_UpgradeTo_Call Centre Supervisor_MST": "Upgrade to CXA Advanced to access this feature",
	"NAME": "ReportPortalInfo"
}